import React, { useContext } from 'react';
import { Plus } from 'lucide-react';
import { WindowSizeContext } from '/src/App';

const ProjectCardSolvingFor = ({ project }) => {
    const { deviceType } = useContext(WindowSizeContext);
    const SECTION_HEADER = "What You're Solving For";
    const imageUrl = `${import.meta.env.VITE_CONTENT_CDN_BASE_URL}`;
    console.log('Project:', project);

    // Simple function that replaces "-black" with "-white" in the icon_black string if risk_level is high or medium
    const getIconUrl = (icon, risk_level) => {
        
        // Make the risk level lowercase
        const lowerRiskLevel = risk_level.toLowerCase();
        console.log(`Icon: ${icon} - Risk Level: ${lowerRiskLevel}`);

        // If risk_level is high or medium, replace "-black" with "-white" in the icon_black string
        if (lowerRiskLevel === 'high' || lowerRiskLevel === 'medium') {
            
            const refinedIcon = icon.replace('-Black', '-White');
            console.log('Refined Icon:', refinedIcon);
            return refinedIcon;
        }
        return icon;
    };

    return (
        <div className={`project-card-section-container ${deviceType}`}>
            <h2 className="project-card-section-header box-shadow-standard">{SECTION_HEADER}</h2>
            
            <div className={`individual-project-solving-content ${deviceType}`}>
                <div className={`individual-project-icons-container ${deviceType}`}>
                    <div className={`individual-project-icon-group ${deviceType}`}>
                        <div className={`individual-project-house-icon ${deviceType} box-shadow-standard ${project.house_category_risk_level.toLowerCase()}`}>
                            <img 
                                src={`${imageUrl}/${getIconUrl(project.house_category_icon, project.house_category_risk_level)}`} 
                                alt="House category"
                            />
                        </div>
                        <span className={`individual-project-icon-label ${deviceType}`}>{project.project_home_category}</span>
                    </div>
                    
                    <Plus size={34} className={`individual-project-plus-sign ${deviceType}`}/>
                    
                    <div className={`individual-project-climate-risks ${deviceType}`}>
                        {project.project_associated_climate_risks.map((risk, index) => (
                            <div key={index} className="individual-project-icon-group">
                                <div className={`individual-project-risk-icon box-shadow-standard ${risk.risk_level.toLowerCase()}`}>
                                    <img 
                                        src={`${imageUrl}/${risk.icon_white}`} 
                                        alt={risk.risk_name}
                                    />
                                </div>
                                <span className="individual-project-icon-label">{risk.risk_name}</span>
                            </div>
                        ))}
                    </div>
                </div>
                
                <p className={`individual-project-solving-description ${deviceType} text-align-center`}>
                    {project.project_solving_for}
                </p>
            </div>
        </div>
    );
};

export default ProjectCardSolvingFor;
